import Alert from "@mui/material/Alert";

export default function PausedStatusWarningAlert() {
  return (
    <Alert severity="warning" sx={{ mb: 1, flexShrink: 0 }}>
      <strong>Ambient Scribe: Paused</strong>. Recording saved for later —{" "}
      <strong>Resume</strong> recording, add <strong>Scribe Context</strong>, or{" "}
      <strong>Complete Scribe</strong> when you are ready to generate.
    </Alert>
  );
}
